import React from "react";
import { MessageSquareText } from "lucide-react";
import CrudModule from "@/components/CrudModule";

const DEPTS = ["Usinagem", "Testes", "Pintura", "Instrumentacao", "Montagem", "Qualidade", "Caldeiraria", "Administrativo", "Geral"];

export default function SafetyTalks() {
  return (
    <CrudModule
      title="Diálogo Diário de Segurança (DDS)"
      subtitle="Registro de DDS conforme ISO 45001 e NR-01"
      icon={MessageSquareText}
      endpoint="safety-talks"
      exportKey="safety-talks"
      testid="dds"
      columns={[
        { key: "date", label: "Data" },
        { key: "title", label: "Título" },
        { key: "theme", label: "Tema" },
        { key: "department", label: "Setor" },
        { key: "presenter_name", label: "Facilitador" },
        { key: "attendee_count", label: "Participantes" },
        { key: "document", label: "Ata/Lista", file: true, idKey: "document_id" },
      ]}
      fields={[
        { name: "title", label: "Título do DDS", type: "text", required: true, full: true },
        { name: "theme", label: "Tema abordado", type: "text", full: true },
        { name: "date", label: "Data", type: "date", required: true },
        { name: "department", label: "Setor", type: "select", options: DEPTS, default: "Geral" },
        { name: "presenter_name", label: "Facilitador", type: "text" },
        { name: "attendee_count", label: "Nº de participantes", type: "number" },
        { name: "document", label: "Lista de presença / Ata (PDF)", type: "file", idKey: "document_id", nameKey: "document_name", full: true },
      ]}
    />
  );
}
